import { t } from "i18next";
import React from "react";

import type { ICaaCustomerAddress } from "@repo/shopifyV2/interface/customer-account";

import Button from "@atoms/Button";

import useCustomerCaa from "@queries/useCustomerCaa";

import { useLayoutStore } from "@store/layout";

interface IProps {
  address: ICaaCustomerAddress;
  isDefaultAddress?: boolean;
  onCompletedMutation?: () => void | Promise<void>;
  openAddressForm?: (address: ICaaCustomerAddress) => void;
}

export default function AddressItemJp({ address, isDefaultAddress = false, onCompletedMutation, openAddressForm }: IProps) {
  const { openModal } = useLayoutStore();
  const { deleteCaaAddress, deleteCaaAddressLoading } = useCustomerCaa();

  const handleDeleteAddress = () => {
    openModal({
      title: "Delete Address",
      content: <p>{t("address_book.delete_address")}</p>,
      confirm: {
        label: "Delete",
        onClick: () => {
          void deleteCaaAddress({ addressId: address.id }).then(() => {
            void onCompletedMutation?.();
            openModal(null);
          });
        },
      },
      cancel: {
        label: "Cancel",
        onClick: () => {
          openModal(null);
        },
      },
    });
  };

  return (
    <div className="flex flex-col gap-2.5">
      {isDefaultAddress ? <span className="text-blue">Default</span> : <span className="pc:invisible pc:block hidden">Address</span>}
      <div className="flex flex-col">
        <span>{address.name || `${address.lastName || ""} ${address.firstName || ""}`}</span>
        {(address.formatted ?? []).map((line, index) => (
          <span key={`${address.id}-${index}`}>{line}</span>
        ))}
        {address.phoneNumber ? <span>{address.phoneNumber}</span> : null}
      </div>
      <div className="flex gap-2.5">
        <Button
          as="text"
          disabled={deleteCaaAddressLoading}
          onClick={() => {
            window.scrollTo(0, 0);
            openAddressForm?.(address);
          }}
        >
          Edit
        </Button>
        <Button as="text" disabled={deleteCaaAddressLoading} onClick={handleDeleteAddress}>
          Delete
        </Button>
      </div>
    </div>
  );
}
